module.exports = __webpack_public_path__ + "static/media/noimage.ce45efbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/noimage.png
// module id = 117
// module chunks = 0